<label [class.readonly]="readonly" [for]="id">
  <input #input 
    [id]="id" 
    [name]="group" 
    [value]="val" 
    [readonly]="readonly"
    [type]="type"
    (blur)="onTouched()" 
    (change)="onInputChange($event?.target)" 
  />
  <i *ngIf="icon" [attr.data-name]="val" [style.background-image]="'url('+icon+')'"></i>
  <div *ngIf="label" class="label" [innerHTML]="label"></div>
  <ng-content select=".label,.htmllabel"></ng-content>
  <span [ngClass]="theme">
    <ng-content select=".incheckbox"></ng-content>
  </span>
</label>
<ng-content></ng-content>